<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'reports.edit.title' | translate }}</p>

    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="dismiss()"
    ></i>
  </div>
  <div class="modal-body">
    <form
      class="ps-4 pe-4"
      (ngSubmit)="dismiss()"
      [formGroup]="form"
      novalidate
    >
      <div class="row">
        <div class="form-group col-12">
          <div class="form-group">
            <div class="form-group row align-items-center mb-1">
              <label
                for="language"
                class="label col-sm-3 form-control-label mb-0"
                >{{ 'reports.edit.product' | translate }}</label
              >
              <div class="col-sm-9">
                <b>{{ productName() }}</b>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-12">
          <div class="form-group">
            <div class="form-group row align-items-center mb-1">
              <label
                for="language"
                class="label col-sm-3 form-control-label mb-0"
                >{{ 'reports.edit.language' | translate }}</label
              >
              <div class="col-sm-9">
                <ng-container>
                  <app-select
                    id="language"
                    placeholder="{{
                      'reports.edit.selectLanguage' | translate
                    }}"
                    formControlName="languageId"
                    data-cy="language-select"
                    [status]="
                      c('languageId').dirty
                        ? c('languageId').invalid
                          ? 'danger'
                          : 'success'
                        : ''
                    "
                  >
                    @for (language of languages(); track language.id) {
                      <app-select-option
                        [value]="language.id"
                        [label]="language.name"
                      />
                    }
                  </app-select>
                </ng-container>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="offset-sm-3 col-sm-9 ps-4">
                <app-validation-error
                  for="languageId"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-group row align-items-center mb-1">
            <label for="signee" class="label col-sm-3 form-control-label mb-0"
              >{{ 'reports.edit.signee' | translate }}
            </label>
            <div class="col-sm-9">
              <ng-container>
                <app-select
                  id="signee"
                  formControlName="signeeId"
                  data-cy="signee-select"
                  [placeholder]="'reports.edit.selectSignee' | translate"
                  [status]="
                    c('signeeId').dirty
                      ? c('signeeId').invalid
                        ? 'danger'
                        : 'success'
                      : ''
                  "
                >
                  @for (signee of signees(); track signee.id) {
                    <app-select-option
                      [value]="signee.id"
                      [label]="signee.name"
                    />
                  }
                </app-select>
              </ng-container>
            </div>
          </div>
          <div class="row align-items-center mb-2">
            <div class="offset-sm-3 col-sm-9 ps-4">
              <app-validation-error
                for="signeeId"
                translations="validation.generic"
              ></app-validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <div class="form-group">
            <p class="caption mb-1">
              {{ 'reports.edit.invalidValues' | translate }}
            </p>
            <hr class="mt-0" />
            <app-data-table
              [configuration]="invalidValuesDataTableConfiguration"
            ></app-data-table>
          </div>
        </div>
      </div>
      <div class="row" formGroupName="analysisData">
        @if (fieldShown('autosomalAneuploidies')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="autosomalAneuploidies"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.autosomalAneuploidies' | translate }}
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="autosomalAneuploidies"
                  formControlName="autosomalAneuploidies"
                  data-cy="autosomalAneuploidies-input"
                />
                <small class="form-text text-muted">
                  {{
                    'reports.edit.autosomalAneuploidiesInstruction' | translate
                  }}
                </small>
                <app-validation-error
                  for="autosomalAneuploidies"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('deletionDuplication')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="deletionDuplication"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.deletionDuplication' | translate }}
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="deletionDuplication"
                  formControlName="deletionDuplication"
                  data-cy="deletionDuplication-input"
                />
                <small class="form-text text-muted">
                  {{
                    'reports.edit.deletionDuplicationInstruction' | translate
                  }}
                </small>
                <app-validation-error
                  for="deletionDuplication"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('deletionDuplicationSyndromes')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="deletionDuplicationSyndromes"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.deletionDuplicationSyndromes' | translate }}
              </label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  id="deletionDuplicationSyndromes"
                  formControlName="deletionDuplicationSyndromes"
                  data-cy="deletionDuplicationSyndromes-input"
                />
                <small class="form-text text-muted">
                  {{
                    'reports.edit.deletionDuplicationSyndromesInstruction'
                      | translate
                  }}
                </small>
                <app-validation-error
                  for="deletionDuplicationSyndromes"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('pregnancyType')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="pregnancyType"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.pregnancyType' | translate }}
              </label>
              <div class="col-sm-9">
                <app-select
                  id="pregnancyType"
                  formControlName="pregnancyType"
                  data-cy="pregnancyType-select"
                  [placeholder]="'reports.edit.selectPregnancyType' | translate"
                >
                  @for (
                    pregnancyType of Object.values(PregnancyType);
                    track pregnancyType
                  ) {
                    <app-select-option
                      [value]="pregnancyType"
                      [label]="pregnancyType"
                    />
                  }
                </app-select>
                <app-validation-error
                  for="pregnancyType"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('gender')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="gender"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.gender' | translate }}
              </label>
              <div class="col-sm-9">
                <app-select
                  id="gender"
                  formControlName="gender"
                  data-cy="gender-select"
                  [placeholder]="'reports.edit.selectGender' | translate"
                >
                  @for (gender of Object.values(Gender); track gender) {
                    <app-select-option [value]="gender" [label]="gender" />
                  }
                </app-select>
                <app-validation-error
                  for="gender"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('diGeorgeSyndromeDetected')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="diGeorgeSyndromeDetected"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.diGeorgeSyndrome' | translate }}
              </label>
              <div class="col-sm-9">
                <app-select
                  id="diGeorgeSyndromeDetected"
                  formControlName="diGeorgeSyndromeDetected"
                  data-cy="diGeorgeSyndrome-select"
                  [placeholder]="
                    'reports.edit.selectDetectionStatus' | translate
                  "
                >
                  <app-select-option
                    [value]="true"
                    [label]="'reports.edit.detected' | translate"
                  />
                  <app-select-option
                    [value]="false"
                    [label]="'reports.edit.notDetected' | translate"
                  />
                </app-select>
                <app-validation-error
                  for="diGeorgeSyndromeDetected"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('yChromosomeDetected')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="yChromosomeDetected"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.yChromosomeDetected' | translate }}
              </label>
              <div class="col-sm-9">
                <app-select
                  id="yChromosomeDetected"
                  formControlName="yChromosomeDetected"
                  data-cy="yChromosomeDetected-select"
                  [placeholder]="
                    'reports.edit.selectYChromosomeDetected' | translate
                  "
                >
                  <app-select-option
                    [value]="true"
                    [label]="'reports.edit.detected' | translate"
                  />
                  <app-select-option
                    [value]="false"
                    [label]="'reports.edit.notDetected' | translate"
                  />
                </app-select>
                <app-validation-error
                  for="yChromosomeDetected"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (fieldShown('monoInterpretation')) {
          <div class="form-group col-12">
            <div class="form-group row align-items-start mb-1">
              <label
                for="interpretation"
                class="label col-sm-3 form-control-label mb-0 pt-2"
              >
                {{ 'reports.edit.interpretation' | translate }}
              </label>
              <div class="col-sm-9">
                <quill-editor
                  class="interpretation-editor d-block w-100"
                  id="interpretation"
                  formControlName="monoInterpretation"
                  format="html"
                  theme="snow"
                  [modules]="interpretationEditorModules"
                  [formats]="interpretationEditorFormats"
                  (onEditorCreated)="onInterpretationEditorCreated($event)"
                ></quill-editor>
                <app-validation-error
                  for="monoInterpretation"
                  translations="validation.generic"
                ></app-validation-error>
              </div>
            </div>
          </div>
        }
        @if (geneticVariants.length) {
          <div class="form-group col-12" formArrayName="geneticVariants">
            <p class="caption mb-1">
              {{ 'reports.edit.geneticVariants.title' | translate }}
            </p>
            <hr class="mt-0" />
            @for (
              geneticVariant of geneticVariants.controls;
              track geneticVariant;
              let index = $index
            ) {
              <div
                class="border rounded-1 p-3 mb-3"
                [formGroupName]="index"
                [attr.data-cy]="'geneticVariants-' + index + '-group'"
              >
                <p class="caption mb-3">
                  {{
                    'reports.edit.geneticVariants.variantTitle'
                      | translate: { index: index + 1 }
                  }}
                </p>
                <div class="row">
                  @for (
                    field of GENETIC_VARIANT_FIELDS;
                    track field.controlName
                  ) {
                    @if (geneticVariantFieldShown(index, field.controlName)) {
                      <div class="form-group col-12 col-md-6">
                        <label
                          [for]="
                            'geneticVariants-' + index + '-' + field.controlName
                          "
                          class="label form-control-label"
                        >
                          {{
                            'reports.edit.geneticVariants.' + field.controlName
                              | translate
                          }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          [id]="
                            'geneticVariants-' + index + '-' + field.controlName
                          "
                          [formControlName]="field.controlName"
                          [attr.data-cy]="
                            'geneticVariants-' +
                            index +
                            '-' +
                            field.controlName +
                            '-input'
                          "
                        />
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
        <div class="form-group col-12">
          <div class="form-group row align-items-start mb-1">
            <label
              for="supplementaryLaboratorySelect"
              class="label col-sm-3 form-control-label mb-0 pt-2"
            >
              {{ 'reports.edit.supplementaryLaboratoryInfo' | translate }}
            </label>
            <div class="col-sm-9">
              <div class="row g-2">
                <div class="col-sm-5">
                  <app-select
                    id="supplementaryLaboratorySelect"
                    data-cy="supplementaryLaboratoryInfo-select"
                    [selected]="supplementaryLaboratorySelection()"
                    [placeholder]="
                      'reports.edit.placeholders.supplementaryLaboratorySelect'
                        | translate
                    "
                    (changed)="onSupplementaryLaboratoryChange($event)"
                  >
                    @for (
                      supplementaryLaboratory of supplementaryLaboratoryOptions;
                      track supplementaryLaboratory
                    ) {
                      <app-select-option
                        [value]="supplementaryLaboratory"
                        [label]="
                          'reports.edit.supplementaryLaboratoryOptions.' +
                            supplementaryLaboratory | translate
                        "
                      />
                    }
                    <app-select-option
                      [value]="SupplementaryLaboratory.Other"
                      [label]="SupplementaryLaboratory.Other"
                    />
                  </app-select>
                </div>
                @if (
                  supplementaryLaboratorySelection() ===
                  SupplementaryLaboratory.Other
                ) {
                  <div class="col-sm-7">
                    <input
                      type="text"
                      class="form-control"
                      id="supplementaryLaboratoryInfo"
                      formControlName="supplementaryLaboratoryInfo"
                      data-cy="supplementaryLaboratoryInfo-input"
                      [placeholder]="
                        'reports.edit.placeholders.supplementaryLaboratory'
                          | translate
                      "
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      (click)="submit()"
      [disabled]="form.invalid || loading()"
      class="btn btn-primary"
      data-cy="update-btn"
    >
      @if (loading()) {
        <span class="spinner-border spinner-border-sm"></span>
      }
      {{ 'common.buttons.btnUpdate' | translate }}
    </button>
  </div>
</div>
